const MAX_SHOWN_COUNT = 99;

export default function formatUnreadCount(count: number) {
  return count > MAX_SHOWN_COUNT ? `${MAX_SHOWN_COUNT}+` : `${count}`;
}
